<template>
    <v-container
        fluid
        grid-list-lg
    >
        <v-layout wrap>
            <v-flex xs12>
                <v-slide-y-transition mode="out-in">
                    <v-card>
                        <v-card-title
                            dark
                            class="primary white--text pa-4"
                        >
<!--                            :color="$vuetify.theme.dark ? 'accent' : 'primary'"-->

                            <v-btn
                                color="accent"
                                dark
                                @click.native="triggerCreateEvent"
                                v-if="createButton"
                                :disabled="freeze"
                            >
                                <span v-if="createButtonText">
                                    {{ createButtonText }}
                                </span>
                                <span v-else>
                                    New {{ ucFirst(singleItemName) }}
                                </span>
                            </v-btn>


                            <div class="text--white text-uppercase subtitle-1 font-weight-medium px-3">
                                {{ totalItems }}
                                <span v-if="totalItems === 1">Result</span>
                                <span v-else>Results</span>
                            </div>

                            <v-spacer></v-spacer>

                            <div :class="{'searching--closed': !searching}" class="searching">
                                <v-text-field
                                    :id="this.singleItemName +'-search'"
                                    v-model="searchQuery"
                                    append-icon="$mdiClose"
                                    @click:append="searchEnd"
                                    placeholder="Search"
                                    hide-details
                                    :autocomplete="'new-password'"
                                    solo
                                    :disabled="freeze"
                                ></v-text-field>
                            </div>

                            <v-btn
                                icon
                                dark
                                @click.native.stop="searchBegin"
                                v-if="searchButton"
                                :disabled="freeze"
                            >
                                <v-icon>$mdiMagnify</v-icon>
                            </v-btn>

                            <v-btn
                                icon
                                dark
                                @click.native.stop="resetFilters"
                                v-if="filterButton && selectedFiltersCount > 0"
                                :disabled="freeze"
                            >
                                <v-icon>$mdiFilterRemoveOutline</v-icon>
                            </v-btn>

                            <v-btn
                                icon
                                dark
                                @click.native.stop="toggleFilterDrawer"
                                v-if="filterButton"
                                :disabled="freeze"
                            >
                                <v-badge
                                    :value="selectedFiltersCount !== 0"
                                    color="error"
                                    left
                                    overlap
                                >
                                    <span
                                        slot="badge"
                                        v-if="selectedFiltersCount !== 0"
                                    >
                                        {{ selectedFiltersCount }}
                                    </span>
                                    <v-icon>$mdiFilterVariant</v-icon>
                                </v-badge>
                            </v-btn>

                            <slot name="additional-buttons"></slot>

                            <v-btn
                                icon
                                dark
                                @click.native.stop="fetchData"
                                v-if="refreshButton"
                                :disabled="freeze"
                            >
                                <v-icon>$mdiAutorenew</v-icon>
                            </v-btn>

                        </v-card-title>
                        <v-data-table
                            class="elevation-1 alternative bg-alternative"
                            :headers="headers"
                            :items="items"
                            :options.sync="options"
                            :server-items-length="totalItems"
                            :loading="fetching"
                            :footer-props="{
                                'items-per-page-options': $store.getters['application/getPerPage'],
                                'disable-items-per-page' : freeze,
                                'disable-pagination' : freeze,
                            }"
                            multi-sort
                            :disable-filtering="freeze"
                            :disable-pagination="freeze"
                            :disable-sort="freeze"
                            :mobile-breakpoint="breakpoint"
                            dark
                        >
                            <template v-slot:body="{ items, isMobile }">
                                <tbody>
                                <tr
                                    v-for="(item, index) in items"
                                    :key="index"
                                    :class="[isMobile ? 'v-data-table__mobile-table-row' : '', clickable ? 'pointer' : '']"
                                    @click="triggerClickEvent(item)"
                                >
                                    <template v-if="isMobile">
                                            <slot name="card" v-bind:item="item">
                                                <td
                                                    class="v-data-table__mobile-row"
                                                    v-for="(header, headerIndex) in headers"
                                                    :key="headerIndex"
                                                >
                                                    <div class="v-data-table__mobile-row__header">
                                                        {{ header.text }}
                                                    </div>
                                                    <div class="v-data-table__mobile-row__cell">
                                                        {{ getCardValue(item, header.value) }}
                                                    </div>
                                                </td>
                                            </slot>
                                    </template>
                                    <template v-else>
                                        <slot name="row" v-bind:item="item"></slot>
                                    </template>
                                </tr>
                                </tbody>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-slide-y-transition>
            </v-flex>
        </v-layout>
        <slot></slot>
    </v-container>
</template>
<script>
    export default {
        data() {
            return {
                searching: false,
                totalItems: 0,
                items: [],
                fetching: true,
                timeout: null,

                options: {
                    groupBy: [],
                    groupDesc: [],
                    itemsPerPage: 10,
                    multiSort: false,
                    mustSort: false,
                    page: 1,
                    sortBy: [],
                    sortDesc: [],
                },

                previousQuery: '',

                deleteDialog: false,
                deleteWaiting: false,
                deleteItem: null,
            }
        },
        name: 'Index-Table',
        props: {
            'single-item-name': {
                type: String,
                required: true
            },
            'plural-item-name': {
                type: String,
                required: true
            },

            'data-url': {
                type: String,
                default: null
            },
            'additional-data': {
                type: Object,
                default: () => ({})
            },

            'headers': {
                type: Array,
                default: () => ([])
            },

            'create-button': {
                type: Boolean,
                default: false
            },
            'create-button-text': {
                type: String,
                default: ''
            },

            'search-button': {
                type: Boolean,
                default: true
            },

            'refresh-button': {
                type: Boolean,
                default: true
            },

            'filter-button': {
                type: Boolean,
                default: false
            },

            'freeze': {
                type: Boolean,
                default: false
            },

            'force-refresh': {
                type: Boolean,
                default: false
            },

            'clickable': {
                type: Boolean,
                default: false
            },

            'breakpoint': {
                type: Number,
                default: 768
            },
        },
        watch: {
            'searchQuery'() {
                if (!this.fetching) {
                    this.fetchDataDelayed();
                }
                this.setQueryParameter(this.searchQuery);
            },
            'selectedFiltersCount'() {
                this.fetchDataDelayed();
            },
            'forceRefresh'() {
                if (!this.fetching) {
                    this.fetchData();
                }
            },
            'options'() {
                if (!this.fetching) {
                    this.fetchData();
                }
            },
        },
        computed: {
            selectedFiltersCount() {
                return this.$store.getters['table/getSelectedFiltersCount'];
            }
        },
        mounted() {
            this.options.itemsPerPage = this.$store.getters['application/getPerPage'][0];

            this.checkUrl()
                .then(response => {
                    this.fetchData();
                })
                .catch(error => {

                });
            this.createItem = this.createObject;
        },
        methods: {
            fetchDataDelayed() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.fetchData();
                }, 1000);
            },
            fetchData() {

                this.fetching = true;

                if (this.tableFilter.searchQuery !== this.previousQuery) {
                    this.options.page = 1;
                }

                this.setPageParameter(this.options.page);

                this.setSortByParameter(this.options.sortBy, this.options.sortDesc);

                this.setItemsPerPageParameter(this.options.itemsPerPage);


                let url = '/' + this.pluralItemName + '/searchPaginated';

                if (this.dataUrl) {
                    url = this.dataUrl;
                }

                window.axios.post(url + '?page=' + this.options.page, {
                    filter: this.tableFilter,
                    itemsPerPage: this.options.itemsPerPage,
                    sortBy: this.options.sortBy,
                    sortDesc: this.options.sortDesc,
                    ...this.additionalData
                }).then(response => {
                    this.items = response.data[this.pluralItemName].data;
                    this.totalItems = response.data[this.pluralItemName].total;
                    this.fetching = false;

                    this.previousQuery = this.tableFilter.searchQuery;
                });
            },

            searchBegin() {
                this.searching = true;
                setTimeout(() => document.querySelector('#' + this.singleItemName + '-search').focus(), 50)
            },
            searchEnd() {
                this.searching = false;
                this.searchQuery = '';
                document.querySelector('#' + this.singleItemName + '-search').blur();
            },
            toggleFilterDrawer() {
                this.$store.commit('application/setFilterDrawerStatus', !this.$store.getters['application/getFilterDrawerStatus']);
            },
            triggerCreateEvent() {
                this.$emit('create');
            },

            triggerClickEvent(item) {
                this.$emit('click', item)
            },

            getCardValue(item, key) {
                const keyDepth = key.split('.');

                let currentItem = '';

                for (let i = 0, len = keyDepth.length; i < len; i++) {
                    if (currentItem === '') {
                        if (typeof item[keyDepth[i]] == 'undefined') {
                            return '';
                        } else {
                            currentItem = item[keyDepth[i]];
                        }
                    } else {
                        if (typeof currentItem[keyDepth[i]] == 'undefined') {
                            return '';
                        } else {
                            currentItem = currentItem[keyDepth[i]];
                        }
                    }
                }

                return currentItem;
            }
        },
    }
</script>
